/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Buffer } from 'buffer';

import { Endpoint, ZodTypes } from '../index';
import { z } from '../zod';

export enum DatasetImportStates {
  Idle = 'idle',
  Pending = 'pending',
  Importing = 'importing',
  Aborting = 'aborting',
}

const DatasetClusters = z.array(
  z.strictObject({
    database: z.string(),
    databaseOid: z.string().nullable().optional(),
    schemaOid: z.string().nullable().optional(),
    transactionEnd: z.date().nullable().optional(),
    isReadonly: z.boolean(),
    isPresent: z.boolean(),
    isConflictingOid: z.boolean(),
    isCloned: z.boolean(),
    status: z.nativeEnum(DatasetImportStates),
    // allowReimport: z.boolean(),
  }),
);

export const DatasetSchema = z.array(
  z.strictObject({
    id: ZodTypes.Id,
    identifier: z.string(),
    name: z.string(),
    description: z.string(),
    database: z.string(),
    schema: z.string(),
    extensions: z.optional(z.array(z.string())),
    rawSizeMb: z.string(),
    finalSizeMb: z.string(),
    importSizeMb: z.string(),
    visible: z.boolean(),
    exists: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date().nullable(),
    category: z.strictObject({
      id: ZodTypes.Id,
      identifier: z.string(),
      thumbnail: z.instanceof(Buffer).optional(),
    }),
    clusters: DatasetClusters.optional(),
  }),
);

export const AdminDataset = {
  id: 'admin-dataset.get',
  tag: 'Admin',
  summary: 'Admin Dataset',
  description: 'Get all datasets',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => '/administration/dataset',
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: DatasetSchema,
        },
      },
    },
  },
} as const satisfies Endpoint;
